import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';

import { KYMW0902Component } from './kymw0902.component';

/**
 * 業態別企画設定画面 モジュール設定クラス
 *
 * @export KYMW0902Module
 * @class KYMW0902Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
  ],
  declarations: [
    KYMW0902Component,
  ],
  providers: [
  ],
})
export class KYMW0902Module {

}
